import { render, staticRenderFns } from "./StepNav.vue?vue&type=template&id=4741dec4&scoped=true"
import script from "./StepNav.vue?vue&type=script&lang=js"
export * from "./StepNav.vue?vue&type=script&lang=js"
import style0 from "./StepNav.vue?vue&type=style&index=0&id=4741dec4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741dec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4741dec4')) {
      api.createRecord('4741dec4', component.options)
    } else {
      api.reload('4741dec4', component.options)
    }
    module.hot.accept("./StepNav.vue?vue&type=template&id=4741dec4&scoped=true", function () {
      api.rerender('4741dec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/reportbuilder/StepNav.vue"
export default component.exports